import { retrieveErrorFromApi } from '../../../helper'
import { setAppErrors } from '../../action/system'
import { setMenuCardCopyTasks } from '../../action/menuCardCopyTask'
import getOwnMenuCardCopyTasks from '../../axios/menuCardCopyTask/get'

export const getOwnMenuCardCopyTasksThunk = () => dispatch => {
	return getOwnMenuCardCopyTasks()
		.then((res) => {
			dispatch(setMenuCardCopyTasks(res.data.tasks))
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}
